import { createContext } from "react"
export const store = createContext(null);
export const initialState = {
    title:'باربری ها',
    category:'کلیه باربری ها'
}
export function reducer(state,actions){
    const {payload,type} = actions;
    switch (type) {
        case 'CHANGE_TITLE_CATEGORY':
            return {...state,title:payload.title,category:payload.category};
        default:
            return {...state};
    }
}
export const actions = {

}
